import { reverseRecord } from '@didaskill/types/misc';

export enum TEACHER_APPOINTMENT_REASONS {
  LESSON_QUESTION = 'LESSON_QUESTION',
  ASSIGNMENT_CORRECTION = 'ASSIGNMENT_CORRECTION',
  CAREER_MONITORING = 'CAREER_MONITORING',
  INTERNSHIP_QUESTION = 'INTERNSHIP_QUESTION',
  INTERNSHIP_MONITORING = 'INTERNSHIP_MONITORING',
  EXAM_PREPARATION = 'EXAM_PREPARATION',
  OTHER_TEACHER = 'OTHER_TEACHER',
  MOCK_ORAL = 'MOCK_ORAL',
}

export enum COACH_APPOINTMENT_REASONS {
  ONBOARDING = 'ONBOARDING',
  LOW_MOTIVATION = 'LOW_MOTIVATION',
  METHODOLOGY = 'METHODOLOGY',
  ORGANIZATION = 'ORGANIZATION',
  OTHER_COACH = 'OTHER_COACH',
}

export enum APPOINTMENT_TYPES {
  COACHING = 'COACHING',
  EDUCATIONAL = 'EDUCATIONAL',
  ONBOARDING = 'ONBOARDING',
  INTERNSHIP = 'INTERNSHIP',
  MOCK_ORAL = 'MOCK_ORAL',
}

export const CALENDLY_APPOINTMENT_TYPES_REASONS: Record<
  COACH_APPOINTMENT_REASONS | TEACHER_APPOINTMENT_REASONS,
  APPOINTMENT_TYPES
> = {
  [COACH_APPOINTMENT_REASONS.ONBOARDING]: APPOINTMENT_TYPES.ONBOARDING,
  [COACH_APPOINTMENT_REASONS.METHODOLOGY]: APPOINTMENT_TYPES.COACHING,
  [COACH_APPOINTMENT_REASONS.ORGANIZATION]: APPOINTMENT_TYPES.COACHING,
  [COACH_APPOINTMENT_REASONS.LOW_MOTIVATION]: APPOINTMENT_TYPES.COACHING,
  [COACH_APPOINTMENT_REASONS.OTHER_COACH]: APPOINTMENT_TYPES.COACHING,

  [TEACHER_APPOINTMENT_REASONS.LESSON_QUESTION]: APPOINTMENT_TYPES.EDUCATIONAL,
  [TEACHER_APPOINTMENT_REASONS.ASSIGNMENT_CORRECTION]: APPOINTMENT_TYPES.EDUCATIONAL,
  [TEACHER_APPOINTMENT_REASONS.CAREER_MONITORING]: APPOINTMENT_TYPES.EDUCATIONAL,
  [TEACHER_APPOINTMENT_REASONS.INTERNSHIP_QUESTION]: APPOINTMENT_TYPES.INTERNSHIP,
  [TEACHER_APPOINTMENT_REASONS.INTERNSHIP_MONITORING]: APPOINTMENT_TYPES.INTERNSHIP,
  [TEACHER_APPOINTMENT_REASONS.EXAM_PREPARATION]: APPOINTMENT_TYPES.EDUCATIONAL,
  [TEACHER_APPOINTMENT_REASONS.OTHER_TEACHER]: APPOINTMENT_TYPES.EDUCATIONAL,
  [TEACHER_APPOINTMENT_REASONS.MOCK_ORAL]: APPOINTMENT_TYPES.MOCK_ORAL,
};

export const CALENDLY_APPOINTMENT_TYPES: Record<APPOINTMENT_TYPES, string> = {
  [APPOINTMENT_TYPES.COACHING]: 'rdvcoaching',
  [APPOINTMENT_TYPES.EDUCATIONAL]: 'suivipeda',
  [APPOINTMENT_TYPES.ONBOARDING]: 'ep',
  [APPOINTMENT_TYPES.INTERNSHIP]: 'suivistage',
  [APPOINTMENT_TYPES.MOCK_ORAL]: 'oralblanc',
};

export const CALENDLY_TYPES_MAPPING = reverseRecord(CALENDLY_APPOINTMENT_TYPES);

export const NB_DAYS_BEFORE_FORCING_FIRST_MEETING_WITH_TEACHER = 7;

export const NB_DAYS_BEFORE_FORCING_FIRST_MEETING_WITH_COACH = 15;

export const CALENDLY_DIDASKILL_SOURCE = 'didaskill';
